import { NavLink } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { filterMenuByRole } from './menu';
import { cn } from '@/lib/cn';

export function Sidebar() {
  const { user } = useAuth();
  if (!user) return null;

  const sections = filterMenuByRole(user.role);

  return (
    <aside className="flex w-60 shrink-0 flex-col gap-6 border-r border-brand-gray-light bg-white px-3 py-5">
      <nav aria-label="Main navigation" className="flex flex-col gap-5">
        {sections.map((section) => (
          <div key={section.label}>
            <h3 className="px-3 pb-2 text-xs font-semibold uppercase tracking-wider text-brand-gray-mid">
              {section.label}
            </h3>
            <ul className="space-y-0.5">
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.to === '/'}
                      className={({ isActive }) =>
                        cn(
                          'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                          isActive
                            ? 'bg-brand-red/10 text-brand-red'
                            : 'text-brand-charcoal hover:bg-brand-off-white',
                        )
                      }
                    >
                      <Icon className="h-4 w-4 shrink-0" aria-hidden />
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
